module.exports = __webpack_public_path__ + "static/media/icecekler.d36bef2e.png";